import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import assetsPath from '../../constant.js';

/**
 * Mobile button atom. Used in mobile navigation.
 * stateAid - The stateAid boolean variable. If set at true, stateAid block is shown.
 * urlImages - The urlimages is url of the images.
 *
 */
@customElement('nn-subvention-block-state')
export class subventionBlockState extends LitElement {
  static styles = css`
    .icon-inline {
      align-items: center;
      background: none;
      border: 0;
      border-radius: 0;
      box-shadow: none;
      color: var(--nn-subvention-block-state_icon-inline_color, #000);
      display: flex;
      font-family: 'font-medium';
      font-size: var(
        --nn-subvention-block-state_icon-inline_font-size,
        0.875em
      );
      justify-content: left;
      line-height: 1;
      margin: var(--nn-subvention-block-state_icon-inline_margin, 0);
      padding: var(--nn-subvention-block-state_icon-inline_padding, 0 0 5px);
      text-align: left;
      text-decoration: none;
      text-transform: none;
      vertical-align: inherit;
      width: 100%;
    }
    .icon-inline--image--state {
      flex-shrink: 0;
      height: var(--nn-subvention-block-state_icon-inline--state_height, 40px);
      width: var(--nn-subvention-block-state_icon-inline--state_width, 40px);
    }
    .icon-inline--image--local {
      flex-shrink: 0;
      height: var(--nn-subvention-block-state_icon-inline--local_height, 13px);
      width: var(--nn-subvention-block-state_icon-inline--local_widthh, 53px);
    }
    .icon-inline--text {
      padding: var(
        --nn-subvention-block-state_icon-inline--text_padding,
        0 0 0 16px
      );
    }
    .icon-inline--text_title {
      font-family: 'font-medium';
      padding: var(
        --nn-subvention-block-state_icon-inline--text_title_padding,
        0 0 4px 0
      );
    }
    .icon-inline--text_text {
      color: var(
        --nn-subvention-block-state_icon-inline--text_text_color,
        #686868
      );
      font-family: 'font-light';
    }
    .generic-block {
      border: 0;
      border-radius: var(
        --nn-subvention-block-state_generic-block_border-radius,
        24px
      );
      background: var(--nn-subvention-block-state_generic-block_color, #fff);
      box-shadow: none;
      padding: var(
        --nn-subvention-block-state_generic-block_padding,
        20px 28px
      );
      max-width: var(
        --nn-subvention-block-state_generic-block_max-width,
        584px
      );
    }
    .generic-block_column:first-child {
      border-bottom: 1px solid
        var(
          --nn-subvention-block-state_generic-block_column--first-child_border-bottom-color,
          #dedede
        );
      padding-bottom: var(
        --nn-subvention-block-state_generic-block_column--first-child_padding-bottom,
        15px
      );
    }
    .input {
      border: 0 !important;
      clip: rect(1px, 1px, 1px, 1px) !important;
      -webkit-clip-path: inset(50%) !important;
      clip-path: inset(50%) !important;
      height: 1px !important;
      overflow: hidden !important;
      padding: 0 !important;
      position: absolute !important;
      width: 1px !important;
      white-space: nowrap !important;
    }
    .label {
      align-items: center;
      display: flex;
      cursor: pointer;
    }
    .label:hover {
      border-color: var(
        --nn-subvention-block-state_label--hover_border-color,
        #444
      );
    }
    .input-icon {
      background-color: var(
        --nn-subvention-block-state_input-icon_background-color,
        #fff
      );
      background-repeat: no-repeat;
      background-position: center;
      border: 1px solid
        var(--nn-subvention-block-state_input-icon_border-color, #323232);
      border-radius: var(
        --nn-subvention-block-state_input-icon_border-radius,
        2px
      );
      display: inline-block;
      flex-shrink: 0;
      height: var(--nn-subvention-block-state_input-icon_height, 20px);
      transition: transform
          var(--nn-subvention-block-state_input-icon_transition, 0.3s),
        border var(--nn-subvention-block-state_input-icon_transition, 0.3s);
      width: var(--nn-subvention-block-state_input-icon_width, 20px);
      position: relative;
    }
    .input:checked + label .input-icon {
      background-color: var(
        --nn-subvention-block-state_input--checked_label_input-icon_background-color,
        #598be7
      );
      box-shadow: none;
      border-color: var(
        --nn-subvention-block-state_input--checked_label_input-icon_border-color,
        #598be7
      );
      transition: transform
        var(
          --nn-subvention-block-state_input--checked_label_input-icon_transition
        );
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='10' viewBox='0 0 12 12'%3E%3Cpolyline points='1 6.5 4 9.5 11 2.5' fill='none' stroke='%23FFFFFF' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3E%3C/svg%3E");
    }
    .input:not(:checked):not(:focus) + label .input-icon:hover {
      background-color: var(
        --nn-subvention-block-state_input--not--checked_label_input-icon--hover_background-color,
        #f6f6f6
      );
      border-color: var(
        --nn-subvention-block-state_input--not--checked_label_input-icon--hover_border-color,
        #aaa
      );
    }
    .input:active + label .input-icon {
      transform: scale(0.8);
      transition: transform
        var(
          --nn-subvention-block-state_input--active_label_input-icon_transition,
          0.3s
        );
    }
    .input:focus + label .input-icon {
      border-color: var(
        --nn-subvention-block-state_input--focus_label_input-icon_border-color,
        #000
      );
      box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.15);
    }
    .input:disabled + label .input-icon {
      background-color: var(
        --nn-subvention-block-state_input--disabled_label_input-icon_background-color,
        #fff
      );
      background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIyIiB2aWV3Qm94PSIwIDAgOCAyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KPHJlY3Qgd2lkdGg9IjgiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiNhN2FlYzEiIC8+DQo8L3N2Zz4NCg==');
      box-shadow: none;
      transition: transform
        var(
          --nn-subvention-block-state_input--disabled_label_input-icon_transition,
          0.3s
        );
    }
    .input:disabled + label {
      color: var(
        --nn-subvention-block-state_input--disabled_label_color,
        #a7aec1
      );
      cursor: not-allowed;
      display: flex;
    }
    .input:disabled:checked + label .input-icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='10' viewBox='0 0 12 12'%3E%3Cpolyline points='1 6.5 4 9.5 11 2.5' fill='none' stroke='%23FFFFFF' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3E%3C/svg%3E");
      background-color: var(
        --nn-subvention-block-state_input--disabled--checked_label_input-icon_background-color,
        #a7aec1
      );
      border-color: var(
        --nn-subvention-block-state_input--disabled--checked_label_input-icon_border-color,
        #a7aec1
      );
      box-shadow: none;
      transition: transform
        var(
          --nn-subvention-block-state_input--disabled--checked_label_input-icon_transition,
          0.3s
        );
    }
    .label-description {
      color: var(--nn-subvention-block-state_label-description_color, #494949);
      font-family: 'font-light';
      margin: var(
        --nn-subvention-block-state_label-description_margin,
        10px 0 0 0
      );
    }
    .subvention button {
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;
    }
    .subvention .sub-title {
      font-family: 'font-heavy';
      line-height: 1.167;
      margin: var(
        --nn-subvention-block-state_subvention_sub-title_margin,
        0 0 8px 0
      );
    }
    .subvention .sub-title button {
      position: relative;
      top: 4px;
    }
    .subvention .sub-information {
      color: var(
        --nn-subvention-block-state_subvention_sub-information_color,
        #073a6f
      );
      font-family: 'font-light';
      font-size: var(
        --nn-subvention-block-state_subvention_sub-information_font-size,
        12px
      );
      line-height: 14px;
      margin: var(
        --nn-subvention-block-state_subvention_sub-information_margin,
        8px 0 0 0
      );
    }
    .subvention .sub-information button {
      color: var(
        --nn-subvention-block-state_subvention_sub-information_button_color,
        #073a6f
      );
      font-family: 'font-light';
      font-size: var(
        --nn-subvention-block-state_subvention_sub-information_font-size,
        12px
      );
      line-height: 14px;
      text-decoration: underline;
    }
    .container-icon {
      align-items: center;
      display: flex;
      height: var(--nn-subvention-block-state_container-icon_height, 22px);
      justify-content: center;
      margin: var(
        --nn-subvention-block-state_container-icon_margin,
        0 16px 0 0
      );
      min-width: var(
        --nn-subvention-block-state_container-icon_min-width,
        42px
      );
    }
    @media (min-width: 767px) {
      .generic-block {
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-height: var(
          --nn-subvention-block-state_generic-block_min-height,
          155px
        );
      }
    }
  `;

  @property({ type: String }) titleStateAid = '';

  @property({ type: String }) stateAidInputName = 'state-aid-input';

  @property({ type: String }) stateAidInputId = 'staid-aid';

  @property({ type: Boolean }) stateAidValue = true;

  @property({ type: String }) rsaAidInputName = 'rsa-aid-input';

  @property({ type: String }) rsaAidInputId = 'checkbox-rsa';

  @property({ type: Boolean }) rsaAidValue = true;

  @property({ type: Boolean }) displayRsaInput = false;

  @property({ type: Boolean }) subInformation = true;

  render() {
    return html`
      <div class="subvention">
        <h3 class="sub-title">
          Vous pouvez bénéficier d'une aide financière avec le dispositif
          <b>«&nbsp;Cohésion Numérique des Territoires&nbsp;»</b>
          <!-- button event emit -->
          <button @click=${this.tooltipClick}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 1.9165C6.44316 1.9165 1.9375 6.42217 1.9375 11.979C1.9375 17.5358 6.44316 22.0415 12 22.0415C17.5568 22.0415 22.0625 17.5358 22.0625 11.979C22.0625 6.42217 17.5568 1.9165 12 1.9165ZM12 20.3345C7.38652 20.3345 3.64453 16.5925 3.64453 11.979C3.64453 7.36553 7.38652 3.62354 12 3.62354C16.6135 3.62354 20.3555 7.36553 20.3555 11.979C20.3555 16.5925 16.6135 20.3345 12 20.3345Z"
                fill="#515151"
              />
              <path
                d="M14.5066 7.59238C13.8328 7.00166 12.9434 6.67822 12 6.67822C11.0566 6.67822 10.1672 7.00391 9.49336 7.59238C8.79258 8.20557 8.40625 9.02988 8.40625 9.9126V10.0833C8.40625 10.1821 8.48711 10.263 8.58594 10.263H9.66406C9.76289 10.263 9.84375 10.1821 9.84375 10.0833V9.9126C9.84375 8.92207 10.8118 8.11572 12 8.11572C13.1882 8.11572 14.1562 8.92207 14.1562 9.9126C14.1562 10.6111 13.6621 11.2513 12.8962 11.5455C12.42 11.7274 12.0157 12.0464 11.726 12.4642C11.4317 12.8909 11.279 13.403 11.279 13.9219V14.4048C11.279 14.5036 11.3599 14.5845 11.4587 14.5845H12.5368C12.6356 14.5845 12.7165 14.5036 12.7165 14.4048V13.8949C12.7177 13.6769 12.7845 13.4642 12.9083 13.2847C13.0321 13.1052 13.2071 12.9672 13.4105 12.8887C14.7357 12.3788 15.5915 11.2108 15.5915 9.9126C15.5938 9.02988 15.2074 8.20557 14.5066 7.59238ZM11.1016 16.9204C11.1016 17.1587 11.1962 17.3872 11.3647 17.5557C11.5332 17.7242 11.7617 17.8188 12 17.8188C12.2383 17.8188 12.4668 17.7242 12.6353 17.5557C12.8038 17.3872 12.8984 17.1587 12.8984 16.9204C12.8984 16.6821 12.8038 16.4536 12.6353 16.2851C12.4668 16.1166 12.2383 16.022 12 16.022C11.7617 16.022 11.5332 16.1166 11.3647 16.2851C11.1962 16.4536 11.1016 16.6821 11.1016 16.9204Z"
                fill="#515151"
              />
            </svg>
          </button>
        </h3>
        <div class="generic-block">
          <div class="generic-block_column">
            <div class="icon-inline">
              <img
                class="icon-inline--image--state"
                src="${assetsPath}/images/states-aid.png"
                alt="Investir l'Avenir"
              />
              <div class="icon-inline--text">
                <div class="icon-inline--text_title">
                  <strong> ${this.titleStateAid} </strong>
                </div>
              </div>
            </div>
          </div>
          ${this.displayStateAidInput()} ${this.displayRsaAidInput()}
        </div>
        ${this.displayRsaEligibleQuestion()}
      </div>
    `;
  }

  displayStateAidInput() {
    return html`
      <div class="generic-block_column line-separator">
        <input
          type="checkbox"
          class="input"
          .id="${this.stateAidInputId}"
          name="${this.stateAidInputName}"
          .value="${this.stateAidValue}"
          .checked="${this.stateAidValue}"
          @click=${this.stateAidInputClick}
        />
        <label class="label" for="${this.stateAidInputId}">
          <div class="container-icon">
            <i class="input-icon"></i>
          </div>
          <p class="label-description">
            J’atteste que je ne suis pas éligible à une connexion Internet de
            30&nbsp;Mb/s ou supérieure, et que je n’ai jamais bénéficié de cette
            aide.
          </p>
        </label>
      </div>
    `;
  }

  displayRsaAidInput() {
    if (this.displayRsaInput) {
      return html`
        <div class="generic-block_column line-separator">
          <input
            type="checkbox"
            class="input"
            .id="${this.rsaAidInputId}"
            name="${this.rsaAidInputName}"
            .value="${this.rsaAidValue}"
            .checked="${this.rsaAidValue}"
            @click=${this.rsaAidInputClick}
          />
          <label class="label" for="${this.rsaAidInputId}">
            <div class="container-icon">
              <i class="input-icon"></i>
            </div>
            <p class="label-description">
              J’atteste être éligible à l’un des dix minima sociaux ou mon
              quotient familial CAF ou MSA est inférieur à 700&nbsp;€ mensuel.
            </p>
          </label>
        </div>
      `;
    }
    return null;
  }

  displayRsaEligibleQuestion() {
    if (!this.displayRsaInput && this.subInformation) {
      return html`
        <p class="sub-information">
          Vous bénéficiez d’un minima social ? L’État peut vous accorder
          <button @click=${this.aidClick}>une aide supérieure.</button>
        </p>
      `;
    }
    return null;
  }

  tooltipClick(e: Event) {
    this.dispatchEvent(new CustomEvent('onTooltip', { detail: e }));
  }

  stateAidInputClick(e: Event) {
    this.stateAidValue = !this.stateAidValue;
    this.dispatchEvent(new CustomEvent('onStateAidInput', { detail: e }));
  }

  rsaAidInputClick(e: Event) {
    this.rsaAidValue = !this.rsaAidValue;
    this.dispatchEvent(new CustomEvent('onRsaAidInput', { detail: e }));
  }

  aidClick(e: Event) {
    this.dispatchEvent(new CustomEvent('onAid', { detail: e }));
  }
}
